export const WHATSAPP_COMMUNITY_URL = 'https://chat.whatsapp.com/IiXy7owgnhI76KP96dUFMU';
